addEventListener('DOMContentLoaded', () => {

})

addEventListener('load', () => {
    show_VideoList();
})

function goFullscreen(elm, id) {
    var elementFull = document.getElementById(id);

    if (elementFull.requestFullscreen) {
        elementFull.requestFullscreen();
    } else if (elementFull.webkitRequestFullscreen) { /* Safari */
        elementFull.webkitRequestFullscreen();
    } else if (elementFull.msRequestFullscreen) { /* IE11 */
        elementFull.msRequestFullscreen();
    }

    elm.style.display = 'none';
    document.querySelector('.video-list--modal_header--outscreen').style.display= 'block';
}

function goOutscreen(el) {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
    }

    el.style.display = 'none';
    document.querySelector('.video-list--modal_header--fullscreen').style.display= 'block';
}

function zoomInVideo(elm) {
    document.querySelector('.video-list--modal_inner').classList.add('zoom')

    elm.style.display = 'none';
    document.querySelector('.video-list--modal_header--zoomOut').style.display= 'block';
}

function zoomOutVideo(el) {
    document.querySelector('.video-list--modal_inner').classList.remove('zoom')

    el.style.display = 'none';
    document.querySelector('.video-list--modal_header--zoomIn').style.display= 'block';
}

function togglerShare() {
    document.querySelector('.video-list--modal_header--share-popup').classList.add('popup-active');
    document.querySelector('.video-list--modal_header--share-overlay').classList.add('popup-active');
}

function closeShare() {
    document.querySelector('.video-list--modal_header--share-popup').classList.remove('popup-active');
    document.querySelector('.video-list--modal_header--share-overlay').classList.remove('popup-active');
}

function show_VideoList() {
    document.querySelector('.video-list--body').classList.remove('opacity-0');
}